require('../components/modal_facets')

ModalFacets = LP.module('Searches').ModalFacets
Analytics = LP.module 'Analytics'
ResourceModal = LP.module('Resources').ResourceModal

class WelcomeModal
  constructor: ({@path, @context}) ->
    @render()

  shouldShow: ->
    return false if LP.config.hideModals
    (LP.isDesktop() or LP.isTablet()) and not LP.config.logged_in and not $.cookie('shown_marketing_modal_v1')

  render: ->
    if @shouldShow()
      if LP.config.show_refine_modal
        @getRefineModal()
      else
        @getVideoModal()

  getRefineModal: ->
    $.get @path.replace('NAME', 'refine_search'), @_showRefineModal

  getVideoModal: ->
    setTimeout =>
        $.get @path.replace('NAME', 'welcome_video'), @_showVideoModal
    , 2500

  _showRefineModal: (data) =>
    $.cookie 'shown_marketing_modal_v1', 1, expires: 1
    $('body').append data
    $('#refine-search-modal').modal()
    container = document.getElementById('js-modal-facets');
    ReactDOM.createRoot(container).render(
      ModalFacets(context: @context)
    );

  _showVideoModal: (data) =>
    $.cookie 'shown_marketing_modal_v1', 1, expires: 365
    $('body').append data
    $modal = $ '#welcome-video-modal'
    iframe = $modal.find('iframe')[0]
    player = new Vimeo.Player(iframe)

    player.ready().then ->
      player.on 'play', ->
        Analytics.track 'Play', { category: 'Videos', label: iframe.src }
      player.on 'ended', ->
        Analytics.track 'Finish', { category: 'Videos', label: iframe.src }

    modals = [ResourceModal.$selector(), $('#login-modal')]
    modals = modals.filter (element) -> element.is(':visible')
    if (modals.length)
      modals[0].on 'hide.bs.modal', ->
        setTimeout ->
          $modal.modal()
        , 1500
    else
      $modal.modal()

    $modal.on 'hide.bs.modal', -> player.unload()

LP.module('Searches').WelcomeModal = WelcomeModal
